/**
 * Fotos responsivas.
 *
 * `scripts/responsive-images.mjs` genera, para cada foto de public/images,
 * versiones WebP de 480, 960 y 1600 px (`foto.w480.webp`…). Esta función
 * arma el `srcSet` para que cada navegador descargue solo la que necesita:
 * un celular baja la de 480 o 960 en vez de la original de 1600.
 *
 *   <img {...foto('/images/Wally.jpg', '(min-width: 1024px) 25vw, 100vw')} alt="…" />
 *
 * `sizes` es el ancho con que se VE la foto en cada pantalla; si se exagera,
 * el navegador baja una versión más grande de lo necesario.
 *
 * `src` sigue apuntando al original: es el respaldo para navegadores sin WebP
 * y la URL que ya conoce Google Imágenes.
 */
const FOTO = /^\/images\/.+\.(jpe?g|png)$/i;
const ANCHOS = [480, 960, 1600];

export function foto(src: string, sizes: string): { src: string; srcSet?: string; sizes?: string } {
  if (!FOTO.test(src)) return { src };
  const base = src.replace(/\.(jpe?g|png)$/i, '');
  return {
    src,
    srcSet: ANCHOS.map((w) => `${base}.w${w}.webp ${w}w`).join(', '),
    sizes,
  };
}
